import { arrayOrArray } from '../array';

export interface IParameter {
  name: string;
  value: unknown;
  allowMultiple?: boolean;
}

export class Url {
  base: string;

  #parameters: Record<string, string | string[]> = {};

  constructor(baseUrl: string, public defaultAllowMultiple = true) {
    const [base, query] = baseUrl.split('?');
    this.base = base;
    query?.split('&').forEach((current) => {
      const [name, ...value] = current.split('=');
      this.addParameter(name, value.join('='));
    });
  }

  addParameter(name: string, value: unknown, allowMultiple?: boolean) {
    if (
      (allowMultiple === undefined && !this.defaultAllowMultiple) ||
      allowMultiple === false
    )
      this.#parameters[name] = String(value);
    else
      this.#parameters[name] = this.#parameters[name]
        ? [...arrayOrArray(this.#parameters[name]), String(value)]
        : [String(value)];
  }

  addParameters(parameters: IParameter[]) {
    parameters.forEach((current) =>
      this.addParameter(current.name, current.value, current.allowMultiple),
    );
  }

  getParameter(name: string) {
    return this.#parameters[name];
  }

  toString() {
    const parametersArray = Object.entries(this.#parameters);

    return `${this.base}${
      parametersArray.length > 0
        ? `?${parametersArray
            .map(([name, value]) =>
              Array.isArray(value)
                ? value.map((current) => `${name}=${current}`).join('&')
                : `${name}=${String(value)}`,
            )
            .join('&')}`
        : ''
    }`;
  }
}
